import Index from '@/views/portal/layout/Index'
// import Login from '@/views/common/Login'
import LoginNoPage from '@/views/common/loginNoPage'
import Main from '@/views/portal/functions/Main'

export default [{
		path: '/',
		name: 'index',
		component: Index,
	},
  {
    path: '/loginNoPage',
    name: 'LoginNoPage',
    component: LoginNoPage,
  },
	/*************登录页*************/
	// {
	// 	path: '/login',
	// 	name: 'login',
	// 	component: Login,
	// },
	/*************首页*************/
	{
		path: '/home',
		name: 'home',
		component: Index,
		children: [{
      path: '/',
      component: resolve => require(['@/views/portal/home/Home'], resolve)
    },

    /*************重要新闻*************/
    {
      path: '/keyNewsList',
      meta: {auth: true, title: "重要新闻", isRedirect: true},
      component: Main,
      children: [{
        path: '/',
        component: resolve => require(['@/views/portal/functions/KeyNewsList'], resolve)
      },
      {
        path: '/keyNewsList/detail',
        meta: {auth: true, title: "重要新闻详情", isRedirect: true},
        component: resolve => require(['@/views/portal/functions/KeyNewsDetail'], resolve)
      },
    ]},
		/*************通知通告*************/
		{
			path: '/noticeList',
			meta: {auth: true, title: "通知通告", isRedirect: true},
			component: Main,
			children: [{
				path: '/',
				component: resolve => require(['@/views/portal/functions/NoticeList'], resolve)
			},
			{
				path: '/notice/detail',
				meta: {auth: true, title: "通知通告详情", isRedirect: true},
				component: resolve => require(['@/views/portal/functions/NoticeDetail'], resolve)
			},
			]
		},
		/*************会员信息查询*************/
		{
		  path: '/memberList',
		  meta: {auth: true, title: "会员信息查询", isRedirect: true},
		  component: Main,
		  children: [{
		    path: '/',
		    component: resolve => require(['@/views/portal/functions/MemberInformationList'], resolve)
		  },
		  {
		    path: '/memberList/detail',
		    meta: {auth: true, title: "会员信息详情", isRedirect: true},
		    component: resolve => require(['@/views/portal/functions/MemberInformationDetail'], resolve)
		  },
		]},



		/*************供需平台*************/
		{
		  path: '/supplyAndDemandList',
		  meta: {auth: true, title: "供需对接平台", isRedirect: true},
		  component: Main,
		  children: [{
		    path: '/',
		    component: resolve => require(['@/views/portal/functions/SupplyAndDemandList'], resolve)
		  },
		  {
		    path: '/supplyAndDemand/detail',
		    meta: {auth: true, title: "供需对接平台详情", isRedirect: true},
		    component: resolve => require(['@/views/portal/functions/SupplyAndDemandDetail'], resolve)
		  },
		]},
		/*************行业标准*************/
		{
		  path: '/industryStandardList',
		  meta: {auth: true, title: "行业标准", isRedirect: true},
		  component: Main,
		  children: [{
		    path: '/',
		    component: resolve => require(['@/views/portal/functions/IndustryStandardList'], resolve)
		  },
		  {
		    path: '/industryStandard/detail',
		    meta: {auth: true, title: "行业标准详情", isRedirect: true},
		    component: resolve => require(['@/views/portal/functions/IndustryStandardDetail'], resolve)
		  },
		]},
		/*************常用理事名单*************/
		{
		  path: '/standingDirectorList',
		  meta: {auth: true, title: "常务理事名单", isRedirect: true},
		  component: Main,
		  children: [{
		    path: '/',
		    component: resolve => require(['@/views/portal/functions/StandingDirectorList'], resolve)
		  },
			{
			  path: '/standingDirectorList/detail',
				meta: {auth: true, title: "常务理事详情", isRedirect: true},
			  component: resolve => require(['@/views/portal/functions/DirectorDetail'], resolve)
			},
		]},
		/*************理事名单*************/
		{
		  path: '/directorList',
		  meta: {auth: true, title: "理事名单", isRedirect: true},
		  component: Main,
		  children: [{
		    path: '/',
		    component: resolve => require(['@/views/portal/functions/DirectorList'], resolve)
		  },
			{
			  path: '/directorList/detail',
				meta: {auth: true, title: "理事详情", isRedirect: true},
			  component: resolve => require(['@/views/portal/functions/DirectorDetail'], resolve)
			},
		]},
		/*************会议页面*************/
		{
		  path: '/meeting',
		  meta: {auth: true, title: "会议", isRedirect: true},
		  component: Main,
		  children: [{
		    path: '/',
		    component: resolve => require(['@/views/portal/application/Application'], resolve)
		  },
		]},
		]
  },
  /*************会员风采*************/
  {
    path: '/demeanor',
    name: 'demeanor',
		meta: {auth: true, title: "会员风采", isRedirect: true},
    component: Index,
    children: [{
      path: '/',
      component: resolve => require(['@/views/portal/functions/ElegantDemeanor'], resolve)
    },
		/*************会员动态列表*************/
		{
		  path: '/demeanor/list',
		  meta: {auth: true, title: "会员动态", isRedirect: true},
		  component: Main,
		  children: [{
		    path: '/',
		    component: resolve => require(['@/views/portal/functions/ElegantDemeanorList'], resolve)
		  },
		  {
		    path: '/demeanor/detail',
		    meta: {auth: true, title: "会员动态详情", isRedirect: true},
		    component: resolve => require(['@/views/portal/functions/ElegantDemeanorDetail'], resolve)
		  },]
		},
		/*************学术交流列表*************/
		{
		  path: '/learning/list',
		  meta: {auth: true, title: "学术交流", isRedirect: true},
		  component: Main,
		  children: [{
		    path: '/',
		    component: resolve => require(['@/views/portal/functions/ElegantDemeanorXsList'], resolve)
		  },
		  {
		    path: '/learning/detail',
		    meta: {auth: true, title: "学术交流详情", isRedirect: true},
		    component: resolve => require(['@/views/portal/functions/ElegantDemeanorDetail'], resolve)
		  },]
		},
		],
		},

		/*************协会概况*************/

		{
		  path: '/profile',
		  name: 'profile',
			meta: {auth: true, title: "协会概况", isRedirect: true},
		  component: Index,
		  children: [{
		    path: '/',
		    component: resolve => require(['@/views/portal/functions/AssociationProfile'], resolve)
		  },
			/*************协会简介*************/
			{
			  path: '/profile/list',
			  meta: {auth: true, title: "协会简介", isRedirect: true},
			  component: Main,
			  children: [{
			    path: '/',
			    component: resolve => require(['@/views/portal/functions/AssociationIntroduction'], resolve)
			  },]
		},
		/*************领导介绍*************/
			{
			  path: '/profile/leaders',
			  meta: {auth: true, title: "领导介绍", isRedirect: true},
			  component: Main,
			  children: [{
			    path: '/',
			    component: resolve => require(['@/views/portal/functions/LeadersIntroduction'], resolve)
			  },]
		},
		],
		},
  /*************入会申请*************/
  {
    path: '/application',
    name: 'application',
    component: Index,
    children: [{
      path: '/',
      component: resolve => require(['@/views/portal/functions/MembershipApplication'], resolve)
    },
  ]},

	/*************在线投稿*************/
	{
		path: '/submission',
		name: 'submission',
		component: Index,
		children: [{
			path: '/',
			component: resolve => require(['@/views/portal/functions/OnlineSubmission'], resolve)
		}]
	},

	/*************互动交流*************/
	{
		path: '/interaction',
		name: 'interaction',
		meta: {auth: true, title: "互动交流", isRedirect: true},
		component: Index,
		children: [{
			path: '/',
			component: resolve => require(['@/views/portal/functions/Interaction'], resolve)
		},
		/*************互动交流列表*************/
			{
			  path: '/interaction/list',
			  meta: {auth: true, title: "留言回复", isRedirect: true},
			  component: Main,
			  children: [{
			    path: '/',
			    component: resolve => require(['@/views/portal/functions/InteractionList'], resolve)
			  },
				{
				  path: '/interaction/detail',
				  meta: {auth: true, title: "留言回复", isRedirect: true},
				  component: resolve => require(['@/views/portal/functions/InteractionDetail'], resolve)
				},
				]
		},
		/*************热点关注*************/
			{
			  path: '/rdinteraction/detail',
			  meta: {auth: true, title: "热点关注详情", isRedirect: true},
			  component: Main,
			  children: [{
			    path: '/',
			    component: resolve => require(['@/views/portal/functions/InteractionDetail'], resolve)
			  },
				]
		},
		]
	},


  /*************政策法规*************/
	{
		path: '/regulations',
		name: 'regulations',
		meta: {auth: true, title: "政策法规", isRedirect: true},
		component: Index,
		children: [{
			path: '/',
			component: resolve => require(['@/views/portal/functions/RegulationsList'], resolve)
		},
		/*************政策法规详情*************/
			{
			  path: '/regulations/detail',
			  meta: {auth: true, title: "政策法规详情", isRedirect: true},
			  component: Main,
			  children: [{
			    path: '/',
			    component: resolve => require(['@/views/portal/functions/RegulationsDetail'], resolve)
			  },]
		},
		]
  },

  /*************资料下载*************/
	{
		path: '/download',
		name: 'download',
		component: Index,
		children: [{
			path: '/',
			component: resolve => require(['@/views/portal/functions/DataDownloadList'], resolve)
		}, ]
	},
  /*************产品展示*************/
  {
  	path: '/productDisplay',
  	name: 'productDisplay',
    meta: {auth: true, title: "产品展示", isRedirect: true},
  	component: Index,
  	children: [{
  		path: '/',
  		component: resolve => require(['@/views/portal/functions/ProductDisplayList'], resolve)
  	},
    {
        path: '/productDisplay/detail',
        meta: {auth: true, title: "产品展示详情", isRedirect: true},
        component: Main,
        children: [{
          path: '/',
          component: resolve => require(['@/views/portal/functions/ProductDisplayDetail'], resolve)
        },]
      },
    	{
    	  path: '/productDisplay/gsdetail',
    	  meta: {auth: true, title: "公司产品展示", isRedirect: true},
        component: Main,
        children: [{
         path: '/',
         component: resolve => require(['@/views/portal/functions/ProductAllDisplayDetail'], resolve)
    	}],
      }
      ]
  },
]



// WEBPACK FOOTER //
// ./src/router/portal.js